import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Typography,
  Paper,
} from '@mui/material';
import { LockReset } from '@mui/icons-material';
import { userService } from '../services/api';

const ChangePassword: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleOpen = () => {
    setOpen(true);
    setError('');
    setSuccess('');
    setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setError('');
  };

  const handleSubmit = async () => {
    setError('');
    setSuccess('');

    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (formData.newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }

    try {
      await userService.changePassword(formData.currentPassword, formData.newPassword);
      setSuccess('Password changed successfully');
      setTimeout(() => {
        handleClose();
      }, 2000);
    } catch (error: any) {
      setError(error.response?.data?.message || 'Failed to change password');
    }
  };

  return (
    <Box>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Password Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Change your account password for security
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<LockReset />}
            onClick={handleOpen}
          >
            Change Password
          </Button>
        </Box>
      </Paper>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Current Password"
            type="password"
            value={formData.currentPassword}
            onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="New Password"
            type="password"
            value={formData.newPassword}
            onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
            margin="normal"
            required
            helperText="Must be at least 6 characters"
          />
          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            value={formData.confirmPassword}
            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
            margin="normal"
            required
          />
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {success}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            Change Password
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChangePassword;
